import Link from "next/link";
import styles from "./productsTabsContentV2.module.scss";
import Image from "next/image";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import { svgImages } from "@/lib/svgImages";
import RoundedButton from "../roundedButton/roundedButton";

const ProductsTabsContentV2 = ({
  title,
  description,
  url,
  image,
  isStatic = false,
}) => {
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const buttonRef = useRef(null);
  const rightContentRef = useRef(null);

  useEffect(() => {
    // Reset elements to initial state
    gsap.set(
      [
        titleRef.current,
        descriptionRef.current,
        buttonRef.current,
        rightContentRef.current,
      ],
      {
        opacity: 0,
        y: 30,
      }
    );

    const ctx = gsap.context(() => {
      // Create a timeline for left content elements
      const tl = gsap.timeline();

      tl.fromTo(
        titleRef.current,
        {
          opacity: 0,
          y: 30,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.out",
        }
      );

      // Animate description
      tl.fromTo(
        descriptionRef.current,
        {
          opacity: 0,
          y: 30,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.out",
        },
        "-=0.6"
      );

      // Animate button if it exists
      if (buttonRef.current) {
        tl.fromTo(
          buttonRef.current,
          {
            opacity: 0,
            y: 30,
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: "power2.out",
          },
          "-=0.6"
        );
      }
      if (rightContentRef.current) {
        tl.fromTo(
          rightContentRef.current,
          {
            opacity: 0,
            y: 50,
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: "power2.out",
          },
          "-=0.8"
        );
      }
    });

    return () => ctx.revert();
  }, [title, description, url, image]);

  return (
    <div
      className={`${styles["productsTabsContent"]} ${
        isStatic ? styles["staticProduct"] : ""
      } `}
    >
      <div className={`${styles["left"]}`}>
        <h3 className="font-size-48" ref={titleRef}>
          {title}
        </h3>
        <p
          className={`${styles["description"]} font-size-18`}
          dangerouslySetInnerHTML={{ __html: description }}
          ref={descriptionRef}
        ></p>
        <div className={`${styles["buttonsContainer"]}`}>
          {url && (
            <RoundedButton
              title="Learn More"
              url={url}
              light={false}
              fill={true}
            />
          )}
        </div>
      </div>
      <div className={`${styles["right"]}`}>
        <Image
          ref={rightContentRef}
          className="d-flex-md d-none-xs"
          src={image}
          width={358}
          height={726}
          alt={title}
        />
      </div>
    </div>
  );
};

export default ProductsTabsContentV2;
